import * as React from 'react'

import { inject, observer } from 'mobx-react'

import Dimmer from '~/client/src/shared/components/Dimmer'
import { withErrorBoundary } from '~/client/src/shared/components/ErrorBoundary'
import FormTypeSelectionForm from '~/client/src/shared/components/SitePermitCreationForm/FormTypeSelectionForm'
import UnsafeSitePermitCreationForm from '~/client/src/shared/components/SitePermitCreationForm/WorkflowCreationForm'
import UnsafeWorkflowViewFormWrapper from '~/client/src/shared/components/SitePermitCreationForm/WorkflowViewFormWrapper'

import DesktopFileInput from '../../../components/FileInput/DesktopFileInput'
import DesktopInitialState from '../../../stores/DesktopInitialState'
import LogisticsStore from './Logistics/Logistics.store'
import DesktopLogisticsCalendarStore from './LogisticsCalendar/LogisticsCalendar.store'

const SitePermitCreationForm = withErrorBoundary(UnsafeSitePermitCreationForm)
const WorkflowViewFormWrapper = withErrorBoundary(UnsafeWorkflowViewFormWrapper)

interface IProps {
  logisticsStore: LogisticsStore
  logisticsCalendarStore: DesktopLogisticsCalendarStore

  state?: DesktopInitialState
}

@inject('state')
@observer
export default class LogisticsDialogs extends React.Component<IProps> {
  public render() {
    const {
      logisticsStore,
      logisticsCalendarStore: { calendarEventDates },
    } = this.props

    const {
      isFormTypeSelectionActive,
      isPermitCreationActive,
      isPermitDialogDisplayed,
      isDateMoveConfirmModalOpen,
      displayedWorkflow,
      workflowToDuplicate,
      hidePermitDialog,
      onFormTypeSelectionFormClose,
      onPermitCreationFormClose,
      hideDateMoveConfirmModal,
      previewLinkedWorkflow,
      closeLinkedWorkflowPreview,
      linkedWorkflowToPreview,
    } = logisticsStore

    return (
      <>
        {isFormTypeSelectionActive && (
          <div className="permit-side-view">
            <FormTypeSelectionForm
              onSelect={this.selectFormType}
              onClose={onFormTypeSelectionFormClose}
              titleVariant="panel"
            />
          </div>
        )}
        {isPermitCreationActive && (
          <div className="permit-side-view">
            <SitePermitCreationForm
              close={onPermitCreationFormClose}
              FileInputType={DesktopFileInput}
              calendarEventDates={calendarEventDates}
              workflowToDuplicate={workflowToDuplicate}
              openWorkflow={previewLinkedWorkflow}
            />
            <Dimmer
              shown={!!linkedWorkflowToPreview}
              onClick={closeLinkedWorkflowPreview}
            />
          </div>
        )}
        {isPermitDialogDisplayed && displayedWorkflow && (
          <div className="permit-side-view">
            <WorkflowViewFormWrapper
              key={displayedWorkflow.id}
              workflowToShow={displayedWorkflow}
              onClose={hidePermitDialog}
              FileInputType={DesktopFileInput}
              calendarEventDates={calendarEventDates}
              isDateMoveConfirmModalOpen={isDateMoveConfirmModalOpen}
              hideDateMoveConfirmModal={hideDateMoveConfirmModal}
              openWorkflow={previewLinkedWorkflow}
            />
            <Dimmer
              shown={!!linkedWorkflowToPreview}
              onClick={closeLinkedWorkflowPreview}
            />
          </div>
        )}
        {linkedWorkflowToPreview && (
          <div className="permit-side-view linked-workflow-preview">
            <WorkflowViewFormWrapper
              key={linkedWorkflowToPreview.id}
              workflowToShow={linkedWorkflowToPreview}
              onClose={closeLinkedWorkflowPreview}
              FileInputType={DesktopFileInput}
              calendarEventDates={calendarEventDates}
              openWorkflow={previewLinkedWorkflow}
            />
          </div>
        )}
      </>
    )
  }

  private selectFormType = (formTypeId: string) => {
    const {
      state,
      logisticsStore: { openPermitCreationForm },
    } = this.props

    state.preSelectedPermitTypeId = formTypeId
    openPermitCreationForm()
  }
}
